import { memo, Suspense } from 'react'
import { createLazyComponent } from 'v2/shared/utils/lazy-utils'
import { useCanUseIndiaKyc } from './queries'
import { useIsIndiaIndividualKycEnabled } from './use-india-individual-kyc'

const IndiaKycDialogs = createLazyComponent(
  () => import('v2/pages/settings/india-kyc/india-kyc-dialogs'),
)

// In the app shell, so every page opens India KYC in place and a page swap (an approval lifting the
// Phone Numbers gate) leaves an open dialog up. Only India KYC v2 accounts load the dialogs, and only
// with the permission every route behind them needs: without it a deep link (?action=create) opens
// nothing.
export const IndiaKycDialogsHost = memo(() => {
  const isKycV2 = useIsIndiaIndividualKycEnabled()
  const canUseKyc = useCanUseIndiaKyc()
  return isKycV2 && canUseKyc ? (
    <Suspense fallback={null}>
      <IndiaKycDialogs />
    </Suspense>
  ) : null
})

IndiaKycDialogsHost.displayName = 'IndiaKycDialogsHost'
